import React, { useEffect, useState } from "react";
import "./UserMenu.css"; // Ensure you have the CSS styles set up as previously described
import { useLogin } from "../../context/LoginProvider";
import { useNavigate } from "react-router-dom";
import { useSocket } from "../../context/SocketProvider";
import { useEmbeddings } from "../../context/EmbeddingsProvider";
import AlertBox from "../AlertBox/AlertBox";

const UserMenu = ({ isHomePage = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { isLoggedIn, userData, logoutUser, setLoggedIn, guestData } =
    useLogin();
  const { setEmbeddingsLoaded, setEmbeddings } = useEmbeddings();
  const { socket } = useSocket();
  const [showName, setShowName] = useState("");
  const navigate = useNavigate();
  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };
  const confirmLogout = () => {
    setShowLogoutConfirm(false);
    setLoggedIn(false);
    logoutUser();
    if (guestData.interests.length === 0) {
      setEmbeddingsLoaded(false);
      navigate("/login");
      setEmbeddings([]);
    } else {
      socket.emit("getEmbeddings", { interests: guestData.interests });
      navigate("/login");
    }
  };
  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };
  useEffect(() => {
    let temp = "";

    if (isLoggedIn && userData && userData.name) {
      for (let i = 0; i < 14; i++) {
        if (i >= userData.name.length) break;
        temp += userData.name[i];
      }
      if (temp.length < userData.name.length) temp += "...";
      setShowName(temp);
    }
  }, [userData, isLoggedIn]);
  return (
    <div className="user-menu">
      {isLoggedIn ? (
        <>
          <button className="logout-button" onClick={handleLogout}>
            <div className="sign">
              <svg viewBox="0 0 512 512">
                <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path>
              </svg>
            </div>

            <div className="text">Logout</div>
          </button>
          {showLogoutConfirm && (
            <AlertBox
              message="Are you sure you want to logout?"
              onClose={cancelLogout}
              onConfirm={confirmLogout}
              success="warning"
              isConfirmation={true}
            />
          )}
        </>
      ) : (
        isHomePage && (
          <button
            className="login-button"
            onClick={() => {
              navigate("/login");
            }}
          >
            <svg
              width="108"
              height="40"
              viewBox="0 0 108 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="107"
                height="39"
                rx="11.5"
                stroke="#6616CD"
              />
              <path
                d="M18.001 19.999H32.001M32.001 19.999L28.501 16.999M32.001 19.999L28.501 22.999"
                stroke="#6616CD"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.002 15C25.014 12.825 25.111 11.647 25.879 10.879C26.758 10 28.172 10 31 10H32C34.829 10 36.243 10 37.122 10.879C38 11.757 38 13.172 38 16V24C38 26.828 38 28.243 37.122 29.121C36.242 30 34.829 30 32 30H31C28.172 30 26.758 30 25.879 29.121C25.111 28.353 25.014 27.175 25.002 25"
                stroke="#6616CD"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M52.8 15.116V24.124H58.912V25.5H51.264V15.116H52.8ZM64.2546 25.676C63.476 25.676 62.7613 25.5107 62.1106 25.18C61.46 24.8493 60.9426 24.3747 60.5586 23.756C60.1746 23.1373 59.9826 22.396 59.9826 21.532C59.9826 20.6573 60.1746 19.9107 60.5586 19.292C60.9426 18.6627 61.46 18.1827 62.1106 17.852C62.7613 17.5213 63.476 17.356 64.2546 17.356C65.0333 17.356 65.7426 17.5213 66.3826 17.852C67.0226 18.1827 67.5346 18.6627 67.9186 19.292C68.3026 19.9107 68.4946 20.6573 68.4946 21.532C68.4946 22.396 68.3026 23.1373 67.9186 23.756C67.5346 24.3747 67.0226 24.8493 66.3826 25.18C65.7426 25.5107 65.0333 25.676 64.2546 25.676ZM64.2546 24.348C64.7346 24.348 65.1773 24.2413 65.5826 24.028C65.9986 23.804 66.3293 23.484 66.5746 23.068C66.8306 22.6413 66.9586 22.1293 66.9586 21.532C66.9586 20.924 66.8306 20.4067 66.5746 19.98C66.3293 19.5533 65.9986 19.228 65.5826 19.004C65.1773 18.78 64.7346 18.668 64.2546 18.668C63.7746 18.668 63.3266 18.78 62.9106 19.004C62.4946 19.2173 62.1586 19.5373 61.9026 19.964C61.6466 20.3907 61.5186 20.9133 61.5186 21.532C61.5186 22.1293 61.6413 22.6413 61.8866 23.068C62.1426 23.484 62.4786 23.804 62.8946 24.028C63.3106 24.2413 63.764 24.348 64.2546 24.348ZM73.3177 24.252C72.6564 24.252 72.0484 24.1187 71.4938 23.852C70.9391 23.5853 70.4964 23.196 70.1658 22.684C69.8458 22.172 69.6858 21.5533 69.6858 20.828C69.6858 20.1133 69.8458 19.5 70.1658 18.988C70.4858 18.4653 70.9178 18.0653 71.4618 17.788C72.0164 17.5 72.6351 17.356 73.3177 17.356C73.5204 17.356 73.7124 17.372 73.8938 17.404C74.0751 17.4253 74.2511 17.4627 74.4218 17.516H77.9097V18.956C77.4298 18.956 76.9444 18.876 76.4538 18.716C75.9738 18.556 75.5524 18.3853 75.1898 18.204L75.1418 18.124C75.5044 18.316 75.8191 18.5507 76.0858 18.828C76.3524 19.0947 76.5551 19.3987 76.6938 19.74C76.8431 20.0707 76.9178 20.444 76.9178 20.86C76.9178 21.564 76.7578 22.172 76.4378 22.684C76.1284 23.196 75.6964 23.5853 75.1418 23.852C74.5978 24.1187 73.9898 24.252 73.3177 24.252ZM75.7658 28.732V28.364C75.7658 27.82 75.6164 27.4307 75.3178 27.196C75.0191 26.9613 74.5818 26.844 74.0058 26.844H72.1338C71.7391 26.844 71.4031 26.812 71.1258 26.748C70.8484 26.684 70.6191 26.588 70.4378 26.46C70.2564 26.3427 70.1231 26.1933 70.0378 26.012C69.9524 25.8413 69.9098 25.6493 69.9098 25.436C69.9098 25.02 70.0378 24.7053 70.2938 24.492C70.5498 24.2787 70.8751 24.1453 71.2698 24.092C71.6644 24.028 72.0644 24.0227 72.4698 24.076L73.3177 24.252C72.7098 24.284 72.2458 24.3427 71.9258 24.428C71.6058 24.5133 71.4457 24.6947 71.4457 24.972C71.4457 25.132 71.5098 25.26 71.6378 25.356C71.7658 25.452 71.9471 25.5 72.1818 25.5H74.1338C74.7418 25.5 75.2804 25.5747 75.7498 25.724C76.2298 25.884 76.6031 26.1453 76.8698 26.508C77.1471 26.8813 77.2858 27.388 77.2858 28.028V28.732H75.7658ZM73.3177 22.956C73.7018 22.956 74.0484 22.876 74.3578 22.716C74.6778 22.5453 74.9338 22.3053 75.1258 21.996C75.3178 21.676 75.4138 21.292 75.4138 20.844C75.4138 20.3853 75.3178 19.996 75.1258 19.676C74.9444 19.3453 74.6938 19.1 74.3738 18.94C74.0538 18.7693 73.7018 18.684 73.3177 18.684C72.9338 18.684 72.5764 18.7693 72.2458 18.94C71.9258 19.1 71.6698 19.34 71.4778 19.66C71.2858 19.98 71.1898 20.3747 71.1898 20.844C71.1898 21.292 71.2858 21.676 71.4778 21.996C71.6698 22.3053 71.9258 22.5453 72.2458 22.716C72.5658 22.876 72.9231 22.956 73.3177 22.956ZM81.2074 14.22V15.868H79.3034V14.22H81.2074ZM79.4954 17.516H81.0154V25.5H79.4954V17.516ZM83.1799 17.516H84.7159V25.5H83.1799V17.516ZM87.7559 17.356C88.2039 17.356 88.6092 17.42 88.9719 17.548C89.3345 17.676 89.6439 17.868 89.8999 18.124C90.1559 18.3693 90.3532 18.6787 90.4919 19.052C90.6412 19.4147 90.7159 19.8307 90.7159 20.3V25.5H89.1959V20.636C89.1959 20.0067 89.0412 19.5373 88.7319 19.228C88.4332 18.908 87.9745 18.748 87.3559 18.748C86.8759 18.748 86.4385 18.86 86.0439 19.084C85.6492 19.308 85.3239 19.6067 85.0679 19.98C84.8225 20.3427 84.6732 20.7533 84.6199 21.212L84.6039 20.332C84.6572 19.9053 84.7692 19.5107 84.9399 19.148C85.1212 18.7853 85.3452 18.4707 85.6119 18.204C85.8892 17.9267 86.2092 17.7187 86.5719 17.58C86.9345 17.4307 87.3292 17.356 87.7559 17.356Z"
                fill="#6616CD"
              />
            </svg>
          </button>
        )
      )}
    </div>
  );
};

export default UserMenu;